import React from "react";
import { Link } from "react-router-dom";

const ProductSetup = ({ onMenuClick, active }) => {
  return (
    <>
      <li className="nav-item">
        <Link
          to
          className={`nav-link with-sub ${
            active === "/accounts" ||
            active === "/chart-of-account" ||
            active === "/budget-plan" ||
            active === "/journal-code" ||
            active === "/sub-category" ||
            active === "/journal-voucher" ||
            active === "/cash-count" ||
            active === "/setup"
              ? "active show-sub"
              : ""
          }`}
        >
          <i className="fa fa-briefcase" aria-hidden="true"></i>
          <span>&nbsp;&nbsp; Product Setup</span>
        </Link>
        <ul className="nav-sub">
          
          
          {/* Supply Chain Product Setup */}
          {/* <li className="nav-item">
            <Link
              to="/banks"
              className={`nav-link ${active === "/banks" ? "active" : ""}`}
              onClick={() => onMenuClick("/banks")}
            >
              <i className="fa fa-university" aria-hidden="true"></i>
              &nbsp;&nbsp; Banks
            </Link>
          </li> */}
          <li className="nav-item">
                              <Link
                                to="/unit"
                                className={`nav-link ${
                                  active === "/unit" ? "active" : ""
                                }`}
                                onClick={() => onMenuClick("/unit")}
                              >
                                <i className="fa fa-balance-scale" aria-hidden="true"></i>
                                &nbsp;&nbsp; Unit
                              </Link>
                            </li>
                            <li className="nav-item">
                              <Link
                                to="/product-category"
                                className={`nav-link ${
                                  active === "/product-category" ? "active" : ""
                                }`}
                                onClick={() => onMenuClick("/product-category")}
                              >
                                <i className="fa fa-tags" aria-hidden="true"></i>
                                &nbsp;&nbsp; Product Category
                              </Link>
                            </li>
                            <li className="nav-item">
                              <Link
                                to="/product"
                                className={`nav-link ${
                                  active === "/product" ? "active" : ""
                                }`}
                                onClick={() => onMenuClick("/product")}
                              >
                                <i className="fa fa-cubes" aria-hidden="true"></i>
                                &nbsp;&nbsp; Product
                              </Link>
                            </li>
                            <li className="nav-item">
                              <Link
                                to="/conversion"
                                className={`nav-link ${active === "/conversion" ? "active" : ""}`}
                                onClick={() => onMenuClick("/conversion")}
                              >
                                <i className="fa fa-clone" aria-hidden="true"></i>
                                &nbsp;&nbsp;
                                <span>Product Conversion</span>
                              </Link>
                            </li>
                            <li className="nav-item">
                              <Link
                                to="/product-group"
                                className={`nav-link ${
                                  active === "/product-group" ? "active" : ""
                                }`}
                                onClick={() => onMenuClick("/product-group")}
                              >
                                <i className="fa fa-cubes" aria-hidden="true"></i>
                                &nbsp;&nbsp; Group Products
                              </Link>
                            </li>
          
        </ul>
      </li>
    </>
  );
};

export default ProductSetup;
